"use strict";

const strf = require("./string.format.js");

/*
 *
 * Console logger
 *
 */

class MetaStreamIOLogger {
  constructor({
    constants,
    logPrefix,
    loggingEnabled = false,
    loggingLevel = "INFO",
    loggingCategories = null,
    loggingAlwaysWarn = false,
    loggingAlwaysError = false,
  } = {}) {
    this.constant = constants;
    this.logPrefix = logPrefix ? logPrefix : "";
    this.loggingEnabled = loggingEnabled;
    this.loggingCategories = loggingCategories;

    this.level = { info: 1, warn: 2, error: 3 };

    this.loggingLevel = this.enumLevel(loggingLevel);

    this.alwaysWarn = loggingAlwaysWarn;
    this.alwaysError = loggingAlwaysError;
  }

  enumLevel(level) {
    switch (level) {
      case "INFO":
        return this.level.info;
        break;
      case "WARN":
        return this.level.warn;
        break;
      case "ERROR":
        return this.level.error;
        break;
      default:
        return this.level.info;
    }
  }

  checkCategory(category = null) {
    if (
      this.loggingCategories !== null &&
      this.loggingCategories.length === 0
    ) {
      return true;
    }
    if (!Array.isArray(category)) {
      category = [category];
    }
    for (let cat in category) {
      if (category[cat] === null) {
        return true;
      } else if (
        this.loggingCategories === null ||
        this.loggingCategories === undefined
      ) {
        return true;
      } else if (this.loggingCategories.includes(category[cat])) {
        return true;
      } else {
        return false;
      }
    }
  }

  log(category = null, ...messages) {
    if (
      this.loggingEnabled == true &&
      this.loggingLevel <= this.level.info &&
      this.checkCategory(category)
    ) {
      console.log(this.logPrefix, `<${category}>`, messages.join(" "));
      return true;
    }
  }
  log_unformatted(category = null, ...messages) {
    if (
      this.loggingEnabled == true &&
      this.loggingLevel <= this.level.info &&
      this.checkCategory(category)
    ) {
      console.log(messages.join(" "));
      return true;
    }
  }
  json(category = null, data) {
    if (
      this.loggingEnabled == true &&
      this.loggingLevel <= this.level.info &&
      this.checkCategory(category)
    ) {
      console.log(this.logPrefix, `<${category}>`);
      console.log(JSON.stringify(data, null, 4));
      return true;
    }
  }
  info(category = null, ...messages) {
    if (
      this.loggingEnabled == true &&
      this.loggingLevel <= this.level.info &&
      this.checkCategory(category)
    ) {
      console.log(this.logPrefix, `<${category}>`, messages.join(" "));
      return true;
    }
  }
  warn(category = null, ...messages) {
    if (this.loggingEnabled && this.alwaysWarn) {
      this._warn(category, messages);
    } else if (
      this.loggingEnabled == true &&
      this.loggingLevel <= this.level.warn &&
      this.checkCategory(category)
    ) {
      this._warn(category, messages);
      return true;
    }
  }
  _warn(category, messages) {
    console.warn(this.logPrefix, `<${category}>`, messages.join(" "));
  }
  error(category = null, ...messages) {
    if (this.loggingEnabled && this.alwaysError) {
      this._error(category, messages);
      return true;
    } else if (
      this.loggingEnabled == true &&
      this.loggingLevel <= this.level.error &&
      this.checkCategory(category)
    ) {
      this._error(category, messages);
      return true;
    }
  }
  _error(category, messages) {
    console.error(this.logPrefix, `<${category}>`, messages.join(" "));
  }
}

module.exports = MetaStreamIOLogger;
